/*
 * Automatically focuses on an element when it becomes visible
 * @example:
 *      <input gw-auto-focus>
 */
export default [() => ({
    restrict: 'A',
    link: function (scope, element) {
        scope.$watch(element.is(':visible'), () => {
            element[0].focus();
        });
    }
})];